import { Component, ComponentProps, ReactNode } from 'react';

import ErrorScreen from './components/ErrorScreen';

interface ErrorBoundaryProps extends ComponentProps<'div'> {
	children: ReactNode;
	isPortal?: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps> {
	state = { hasError: false };

	static getDerivedStateFromError(): { hasError: boolean } {
		return { hasError: true };
	}

	componentDidCatch(error: unknown, errorInfo: unknown): void {
		console.error(error, errorInfo);
	}

	render(): ReactNode {
		if (this.state.hasError) {
			return <ErrorScreen isPortal={this.props.isPortal || false} />;
		}
		return this.props.children;
	}
}

export default ErrorBoundary;
